module.exports = __webpack_public_path__ + "media/images/category_icons/practice-667e86e5b08ee6301b57fae88b35eb47.svg";